export default __webpack_public_path__ + "7a935957668f3f7e428f4ad90bc39116.svg";